export default "__VITE_ASSET__DTfQe1s1__"